@if (images.length > 1) {
  <div class="grid">
    @for (row of rows; track row) {
      @for (image of row; track image) {
        <div
          class="tile"
          (click)="onClick(image.index)"
          [style.grid-column]="'span ' + image.colSpan"
        >
          <img [src]="image.url | addBaseUrl" alt="" />
        </div>
      }
    }
  </div>
}
